/**
 * 上传图片，自动监听dom的change事件，根据压缩参数对实际图片进行压缩后返回图片内容，支持ie6789
 * demo:
 * new getUploadImg(dom,{
            maxSize:0,
            quality:0.8,
            start:function(){
              //图片上传前，可用于显示上传按钮loading
            },
            success:function(data){
               //压缩成功后回调
               //data=base64/realpath, //低版本ie是真是图片地址，高版本浏览器是base64图片
            },
            error:function(str){
               //获取失败 或格式失败回调
            },
            before:function(data){
              //压缩前原图二进制数据
              //data=base64/realpath, //低版本ie是真是图片地址，高版本浏览器是base64图片
            }
        })
 */
import { addHandler } from "./tools";
export function getUploadImg(fileInput, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.maxSize, maxSize = _c === void 0 ? 0 : _c, _d = _b.quality, quality = _d === void 0 ? 0.8 : _d, _e = _b.isCompress, isCompress = _e === void 0 ? true : _e, _f = _b.maxWidth, maxWidth = _f === void 0 ? 800 : _f, _g = _b.maxHeight, maxHeight = _g === void 0 ? 800 : _g, 
    // eslint-disable-next-line no-empty-function
    _h = _b.start, 
    // eslint-disable-next-line no-empty-function
    start = _h === void 0 ? function () { } : _h, 
    // eslint-disable-next-line no-empty-function
    _j = _b.before, 
    // eslint-disable-next-line no-empty-function
    before = _j === void 0 ? function (data) { } : _j, 
    // eslint-disable-next-line no-empty-function
    _k = _b.success, 
    // eslint-disable-next-line no-empty-function
    success = _k === void 0 ? function (data) { } : _k, _l = _b.error, error = _l === void 0 ? function (str) {
        alert(str);
    } : _l;
    this.opts = {
        maxSize: maxSize,
        quality: quality,
        isCompress: isCompress,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        start: start,
        before: before,
        success: success,
        error: error
    };
    if (typeof fileInput == "undefined") {
        this._errorCB("缺少参数 fileInput");
    }
    else {
        this.fileInput = fileInput;
        this._init();
    }
}
getUploadImg.prototype = {
    canvas: null,
    ctx: null,
    flag: true,
    isLowerIe: !!(typeof navigator != "undefined" &&
        (navigator.userAgent.indexOf("MSIE 7") >= 0 ||
            navigator.userAgent.indexOf("MSIE 8") >= 0 ||
            navigator.userAgent.indexOf("MSIE 9") >= 0)),
    _init: function () {
        var that = this;
        addHandler(that.fileInput, "change", function () {
            if (that.isLowerIe) {
                // 低版本ie
                that.lowerIeHandle();
                return;
            }
            that.file = that.fileInput.files[0];
            if (!that.flag) {
                return false;
            }
            if (!/image\/\w+/.test(that.file.type)) {
                that._errorCB("只支持上传PNG、JPG 或 JPEG格式的图片！");
                return false;
            }
            if (that.opts.maxSize && that.opts.maxSize > 0 && that.file.size / 1024 > that.opts.maxSize) {
                that._errorCB("\u4E0A\u4F20\u7684\u56FE\u7247\u5FC5\u987B\u5C0F\u4E8E" + that.opts.maxSize + "K");
                return false;
            }
            // 显示加载中
            that.flag = false;
            that.opts.start();
            that._uploadFile(that.fileInput, function (blob) {
                // 将未压缩的数据传递给before函数
                that.opts.before(blob);
                if (that.opts.isCompress) {
                    that._drawImg(blob, that.file);
                }
                else {
                    that.opts.success(blob);
                    that.flag = true;
                }
                that.fileInput.value = ""; // 清空临时数据
            });
        });
    },
    lowerIeHandle: function () {
        // 低版本ie处理
        var that = this;
        that.fileInput.select();
        typeof window != "undefined" && window.parent.document.body.focus();
        if (typeof document == "undefined" ||
            typeof document.selection == "undefined") {
            return false;
        }
        var realpath = document.selection.createRange().text;
        var type = realpath.substr(realpath.lastIndexOf(".")).toLowerCase();
        var AllImgExt = ".jpg|.jpeg|.gif|.bmp|.png|"; // 全部图片格式类型
        if (AllImgExt.indexOf(type + "|") == -1) {
            that._errorCB("只支持上传PNG、JPG 或 JPEG格式的图片！");
            return false;
        }
        that.opts.before(realpath);
        that.opts.success(realpath);
    },
    _uploadFile: function (input, callbackFun) {
        //  获取图片二进制数据
        var that = this;
        // 支持chrome IE10
        if (typeof window != "undefined" && window.FileReader) {
            var filename = that.file.name.split(".")[0];
            var reader = new FileReader();
            reader.onload = function () {
                callbackFun(this.result);
            };
            reader.readAsDataURL(that.file);
        }
        // 支持IE 7 8 9 10
        else if (typeof window != "undefined" &&
            typeof window.ActiveXObject != "undefined") {
            // @ts-ignore
            var xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
            xmlDoc.async = false;
            xmlDoc.load(input.value);
            callbackFun(xmlDoc.xml);
        }
        // 支持FF
        else if (typeof document != "undefined" &&
            document.implementation &&
            document.implementation.createDocument) {
            var xmlDoc = void 0;
            xmlDoc = document.implementation.createDocument("", "", null);
            xmlDoc.async = false;
            xmlDoc.load(input.value);
            callbackFun(xmlDoc.xml);
        }
        else {
            that._errorCB("读取图片你失败！");
        }
    },
    _drawImg: function (blob, file) {
        /**
         * 生成base64
         * @param blob 通过file获得的二进制
         */
        var that = this;
        if (typeof document == "undefined") {
            return false;
        }
        // 生成canvas
        that.canvas = document.createElement("canvas");
        that.ctx = that.canvas.getContext("2d");
        var image = new Image();
        image.src = blob;
        image.onload = function () {
            /* 图片原始大小 */
            var originW = image.width, originH = image.height, width = image.width, height = image.height;
            /* 图片尺寸按配置压缩大小 */
            if (originW >= that.opts.maxWidth) {
                width = that.opts.maxWidth;
                height = (originH * width) / originW;
            }
            else if (height >= that.opts.maxHeight) {
                height = that.opts.maxHeight;
                width = (originW * height) / originH;
            }
            that.canvas.width = width;
            that.canvas.height = height;
            that.canvas.style.width = width / 2;
            that.canvas.style.height = height / 2;
            /* canvas清屏*/
            that.ctx.clearRect(0, 0, that.canvas.width, that.canvas.height);
            /* 将图像绘制到canvas上 */
            that.ctx.drawImage(image, 0, 0, width, height);
            /* "data:image/png;base64,"开头,需要在客户端或者服务器端将其去掉，后面的部分可以直接写入文件。*/
            var base64 = that.canvas.toDataURL(file.type, that.opts.quality);
            // 执行后函数
            that.opts.success(base64);
            that.flag = true;
        };
    },
    _errorCB: function (str) {
        // 错误回调
        var that = this;
        that.flag = true;
        that.opts.error(str);
    }
};
